import { fleetApi } from '../../api/axiosClient';
import { timezone } from '../../utils/timeZone';
const getTzParam = (tz) => {
  const defaultTz = typeof timezone === 'function' ? timezone() : Number(timezone);
  const activeTz =
    tz !== undefined && tz !== null && !isNaN(tz)
      ? Number(tz)
      : !isNaN(defaultTz)
        ? defaultTz
        : Math.abs(new Date().getTimezoneOffset() / 60);
  return `?tz=${activeTz}`;
};
import { useState, useEffect } from 'react';
import { API_BASES } from '../../config/constants';

export const filterReportFuelSummary = async (payload, tz) => {
  try {
    const response = await fleetApi.post(`/report-fuel-summary${getTzParam(tz || payload?.tz)}&withoutLogicAllSensor=true`, payload);
    return response;
  } catch (error) {
    console.error('Error fetching fuel summary report:', error);
    throw error;
  }
};

export const getAllSensorReport = async (payload) => {
  try {
    const defaultTz = typeof timezone === 'function' ? timezone() : Number(timezone);
    const activeTz =
      payload?.tz !== undefined && payload?.tz !== null && !isNaN(payload?.tz) ? Number(payload.tz) : !isNaN(defaultTz) ? defaultTz : 7;

    const params = new URLSearchParams({
      tz: String(activeTz),
      withoutLogicAllSensor: true,
      companyId: payload.company_id,
      vehicleId: payload.vehicle_id,
      startTime: payload.start_date,
      endTime: payload.end_date
    }).toString();

    const response = await fleetApi.get(`/report/all-sensor?${params}`);
    return response;
  } catch (error) {
    console.error('Error fetching sensor report:', error);
    return null;
  }
};
export const datePickerStyle = {
  '& .MuiInputLabel-root': {
    color: '#485D9A',
    '&.Mui-focused': { color: '#485D9A' }
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    }
  }
};
export const LocationCell = ({ lat, lon }) => {
  const [address, setAddress] = useState('Loading...');
  useEffect(() => {
    let isMounted = true;
    const fetchAddress = async () => {
      if (!lat || !lon) {
        if (isMounted) setAddress('-');
        return;
      }
      try {
        const response = await fetch(`${API_BASES.ADDRESS}/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=json&addressdetails=1&limit=1`);
        const result = await response.json();
        if (isMounted) {
          if (result && result.code === 200 && result.data) {
            setAddress(result.data.display_name || '-');
          } else {
            setAddress('-');
          }
        }
      } catch (error) {
        console.error('Error fetching address:', error);
        if (isMounted) setAddress('Error loading address');
      }
    };

    fetchAddress();
    return () => {
      isMounted = false;
    };
  }, [lat, lon]);
  return address;
};
